import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: "Economy Car",
        content: "Affordable and fuel-efficient cars for everyday travel. Ideal for budget-friendly trips.",
        paragraphs: [
            "Our economy cars are designed to provide a comfortable and cost-effective solution for your daily commutes and short trips.",
            "With excellent fuel efficiency, easy handling, and modern features, our economy rental cars are perfect for travelers looking for a smooth and budget-friendly experience."
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2,
        ],
        features: [
            "Fuel-efficient and cost-effective",
            "Comfortable seating for up to 4 passengers",
            "Air conditioning and modern safety features",
            "Smooth driving experience with automatic or manual options",
            "Ideal for city driving and short trips"
        ],
        process: [
            "Choose your preferred economy car from our fleet",
            "Select the rental duration and pickup location",
            "Complete the online booking process",
            "Pick up your vehicle and enjoy your ride",
            "Return the car at the agreed location"
        ],
        faqs: [
            {
                id: 1,
                heading: "What documents are required to rent an economy car?",
                content: "You need a valid driver's license, a government-issued ID, and a credit or debit card for payment."
            },
            {
                id: 2,
                heading: "Is there a mileage limit for economy car rentals?",
                content: "Most rentals include unlimited mileage, but some may have specific limits. Check with our team for details."
            },
            {
                id: 3,
                heading: "Can I extend my rental duration?",
                content: "Yes, you can extend your rental period by contacting our support team in advance."
            },
            {
                id: 4,
                heading: "Are fuel charges included in the rental price?",
                content: "No, the rental price does not include fuel. You are required to return the car with the same fuel level as at pickup."
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: "Luxury Car",
        content: "Premium and high-end cars for a stylish and comfortable ride. Perfect for special occasions.",
        paragraphs: [
            "Experience the perfect blend of luxury, performance, and style with our premium car rentals.",
            "Ideal for business trips, weddings, or any special occasion, our luxury cars offer top-tier comfort, advanced features, and an unmatched driving experience."
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2,
        ],
        features: [
            "High-end interiors with premium comfort",
            "Powerful performance and smooth ride",
            "Advanced safety and entertainment features",
            "Luxury brands like BMW, Mercedes, and Audi",
            "Ideal for weddings, VIP events, and business trips"
        ],
        process: [
            "Select your preferred luxury car from our fleet",
            "Choose rental duration and additional services",
            "Complete the booking process online",
            "Pick up the car or opt for delivery service",
            "Enjoy your luxury ride and return as scheduled"
        ],
        faqs: [
            {
                id: 1,
                heading: "What are the requirements to rent a luxury car?",
                content: "You need a valid driver's license, a government-issued ID, and a credit card for security deposit."
            },
            {
                id: 2,
                heading: "Do luxury cars come with a chauffeur option?",
                content: "Yes, we offer professional chauffeur services for an additional fee."
            },
            {
                id: 3,
                heading: "Is insurance included in the rental price?",
                content: "Basic insurance is included, but additional coverage options are available."
            },
            {
                id: 4,
                heading: "Can I rent a luxury car for just a few hours?",
                content: "Yes, we offer hourly rental options for luxury cars."
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: "SUV Rental",
        content: "Spacious and powerful vehicles for family trips and off-road adventures.",
        paragraphs: [
            "Our SUV rentals offer a perfect blend of comfort, space, and power, making them ideal for long trips and outdoor adventures.",
            "With advanced safety features, high ground clearance, and all-terrain capabilities, our SUVs ensure a smooth and secure ride for your journey."
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2,
        ],
        features: [
            "Spacious interiors with ample legroom",
            "Powerful engines for long-distance travel",
            "Advanced safety and navigation features",
            "Ideal for family vacations and off-road trips",
            "Available in both 2WD and 4WD options"
        ],
        process: [
            "Select your preferred SUV from our fleet",
            "Choose rental duration and additional features",
            "Complete the booking process online",
            "Pick up the SUV or opt for doorstep delivery",
            "Enjoy your ride and return as scheduled"
        ],
        faqs: [
            {
                id: 1,
                heading: "Do you offer 4x4 SUVs for off-road adventures?",
                content: "Yes, we have 4WD options available for off-road trips."
            },
            {
                id: 2,
                heading: "Can I take an SUV on a cross-country trip?",
                content: "Absolutely! Our SUVs are designed for long-distance travel."
            },
            {
                id: 3,
                heading: "Is there a mileage limit for SUV rentals?",
                content: "We offer both unlimited and limited mileage options."
            },
            {
                id: 4,
                heading: "Are child seats available for SUV rentals?",
                content: "Yes, you can add child seats to your rental during booking."
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: "Wedding Rental",
        content: "Elegant and luxurious cars for your special day, ensuring a grand entrance.",
        paragraphs: [
            "Make your wedding day unforgettable with our premium wedding car rentals. Arrive in style with our fleet of elegant and luxurious vehicles.",
            "Our wedding rentals offer chauffeur services, floral decorations, and customizable options to match your wedding theme."
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2,
        ],
        features: [
            "Luxury and classic car options available",
            "Professional chauffeur service included",
            "Customizable decorations to match your theme",
            "Spacious interiors for comfort and elegance",
            "Perfect for bride and groom transportation"
        ],
        process: [
            "Choose your preferred luxury wedding car",
            "Customize decorations and additional features",
            "Schedule the rental time and pickup location",
            "Enjoy a hassle-free ride on your special day",
            "Return or have the vehicle picked up as scheduled"
        ],
        faqs: [
            {
                id: 1,
                heading: "Can I decorate the car according to my wedding theme?",
                content: "Yes, we offer customization options for floral and ribbon decorations."
            },
            {
                id: 2,
                heading: "Do you provide a chauffeur service with wedding rentals?",
                content: "Yes, our wedding rental package includes a professional chauffeur."
            },
            {
                id: 3,
                heading: "How far in advance should I book a wedding car?",
                content: "We recommend booking at least a month in advance to secure your preferred vehicle."
            },
            {
                id: 4,
                heading: "Are there different luxury car models available?",
                content: "Yes, we offer a variety of luxury cars, including limousines and classic vintage models."
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: "Lengthy Rentals",
        content: "Flexible and cost-effective rental plans for extended use, whether personal or business.",
        paragraphs: [
            "Need a car for an extended period? Our lengthy rental plans offer affordable rates and flexible terms, perfect for long-term business or personal use.",
            "Enjoy well-maintained vehicles, comprehensive insurance coverage, and hassle-free maintenance throughout your rental duration."
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2,
        ],
        features: [
            "Flexible rental durations from weeks to months",
            "Affordable rates with no hidden fees",
            "Comprehensive insurance coverage included",
            "Regular maintenance and servicing provided",
            "Ideal for business, corporate, or long vacations"
        ],
        process: [
            "Choose your preferred vehicle from our fleet",
            "Select a rental duration that suits your needs",
            "Sign the rental agreement with flexible terms",
            "Enjoy a worry-free, long-term car rental experience",
            "Return or extend your rental as needed"
        ],
        faqs: [
            {
                id: 1,
                heading: "What is the minimum rental period for lengthy rentals?",
                content: "Our lengthy rentals start from a minimum of one week."
            },
            {
                id: 2,
                heading: "Are there any mileage limits for long-term rentals?",
                content: "Yes, but we offer plans with flexible mileage options to suit your needs."
            },
            {
                id: 3,
                heading: "Can I switch cars during my rental period?",
                content: "Yes, depending on availability, we allow car swaps for an additional fee."
            },
            {
                id: 4,
                heading: "Is maintenance included in lengthy rentals?",
                content: "Yes, regular maintenance and servicing are included at no extra cost."
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: "Airport Transfer",
        content: "Hassle-free airport pick-ups and drop-offs with professional chauffeurs.",
        paragraphs: [
            "Start or end your journey stress-free with our reliable airport transfer service. We provide punctual pick-ups and drop-offs with professional drivers, ensuring a smooth ride.",
            "Whether you're traveling for business or leisure, our comfortable and well-maintained cars guarantee a hassle-free experience to and from the airport."
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2,
        ],
        features: [
            "Punctual pick-ups and drop-offs",
            "Professional and courteous chauffeurs",
            "Luxury and economy car options available",
            "24/7 availability for early or late flights",
            "Flight tracking for real-time scheduling"
        ],
        process: [
            "Select your pick-up and drop-off location",
            "Choose your preferred vehicle",
            "Provide flight details for scheduling",
            "Meet your chauffeur at the designated location",
            "Enjoy a smooth and comfortable ride"
        ],
        faqs: [
            {
                id: 1,
                heading: "Do you track flight delays?",
                content: "Yes, we monitor your flight to adjust the pick-up time accordingly."
            },
            {
                id: 2,
                heading: "Can I book an airport transfer in advance?",
                content: "Absolutely! You can schedule your transfer ahead of time for peace of mind."
            },
            {
                id: 3,
                heading: "Do you offer both pick-up and drop-off services?",
                content: "Yes, we provide both airport pick-up and drop-off services."
            },
            {
                id: 4,
                heading: "What if my flight gets delayed?",
                content: "No worries! We adjust the pick-up time based on real-time flight tracking."
            }
        ]
    },
];

export default services;